import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchTeamLeaders_AE, fetchOtherDiscMembers_AE } from '../../actions/additional_actions';

class TeamMemberSearchAE extends React.Component {
    // static PropTypes = {
    //     onAdd: PropTypes.func.isRequired,
    //     permissionsModule: PropTypes.object.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            queryLeaders: '',
            queryMembers: '',
            queryMembersOther: ''
        }

        this.timerId = 0;
        this.handleSearch = this.handleSearch.bind(this);
        this.addHandler = this.addHandler.bind(this);
    }

    handleSearch(name) {
        return (e) => {

            if (name === 'leader') {
                this.setState({ queryLeaders: e.target.value });

                clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.props.fetchTeamLeaders_AE(this.state.queryLeaders);
                }, 200);
            }

            else if (name === 'member') {
                this.setState({ queryMembers: e.target.value });

                clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.props.fetchTeamLeaders_AE(this.state.queryMembers);
                }, 200);
            }

            else if (name === 'other') {
                this.setState({ queryMembersOther: e.target.value });

                clearTimeout(this.timerId);
                this.timerId = setTimeout(() => {
                    this.props.fetchOtherDiscMembers_AE(this.state.queryMembersOther);
                }, 200);
            }
        }
    }

    addHandler(member, isLeader) {
        return () => {
            this.setState({ queryLeaders: '', queryMembers: '', queryMembersOther: '' });

            this.props.onAdd(member, isLeader);
        }
    }

    renderResults(name) {
        let distinctMembers = this.props.teamLeaders_AE.slice(0);
        let distinctMembersFinal = distinctMembers.slice(0);

        for (let i = distinctMembers.length - 1; i >= 0; i--) {
            for (let j = 0; j < this.props.team.length; j++) {
                if (distinctMembers[i].id === this.props.team[j].member_AE_Id) {
                    distinctMembersFinal.splice(i, 1);
                }
            }
        }

        let distinctMembersOther = this.props.otherMembers_AE.slice(0);
        let distinctMembersOtherFinal = distinctMembersOther.slice(0);

        for (let i = distinctMembersOther.length - 1; i >= 0; i--) {
            for (let j = 0; j < this.props.team.length; j++) {
                if (distinctMembersOther[i].id === this.props.team[j].member_AE_Id) {
                    distinctMembersOtherFinal.splice(i, 1);
                }
            }
        }

        return (
            <div className="results">
                {name === 'leader'
                    ? <ul>
                        {this.props.teamLeaders_AE.map(leader =>
                            <li key={leader.id}>
                                <strong>{leader.employee.firstName + ' ' + leader.employee.lastName}</strong>
                                <span>{leader.lkp_Members_Discipline_AE && leader.lkp_Members_Discipline_AE.memberDiscipline}</span>
                                {<button className="add" onClick={this.addHandler(leader, true)}>+</button>}
                            </li>
                        )}
                    </ul>
                    : null}

                {name === 'member'
                    ? <ul>
                        {distinctMembersFinal.map(leader =>
                            <li key={leader.id}>
                                <strong>{leader.employee.firstName + ' ' + leader.employee.lastName}</strong>
                                <span>{leader.lkp_Members_Discipline_AE && leader.lkp_Members_Discipline_AE.memberDiscipline}</span>
                                {<button className="add" onClick={this.addHandler(leader, false)}>+</button>}
                            </li>
                        )}
                    </ul>
                    : null}

                {name === 'other'
                    ? <ul>
                        {distinctMembersOtherFinal.map(member =>
                            <li key={member.id}>
                                <strong>{member.employee.firstName + ' ' + member.employee.lastName}</strong>
                                <span>{member.lkp_Members_Discipline_AE && member.lkp_Members_Discipline_AE.memberDiscipline}</span>
                                {<button className="add" onClick={this.addHandler(member, false)}>+</button>}
                            </li>
                        )}
                    </ul> : null}
            </div>
        );
    }

    render() {
        const { queryLeaders, queryMembers, queryMembersOther } = this.state;

        var  hasLeader  = false;

        if (this.props.team.length > 0 &&  this.props.team.some(c => c.isTeamLeader === true))
            hasLeader = true;
    
        return (
            <div>

                {!hasLeader 
                    ? <div className="controls required with-select position-relative">
                        <label>Team Leader</label>
                        <div className="section-search search-ae search-leader">
                            <div className="box-wrap">
                                <input type="text" name="search" id={this.props.leaderOrMember}
                                    value={queryLeaders}
                                    onChange={this.handleSearch('leader')}
                                    placeholder="Search for team leaders to add ..." />
                            </div>
                            {queryLeaders ? this.renderResults('leader') : null}
                        </div>
                    </div>
                    : null}

                <div className="controls required with-select position-relative margin-top-2">
                    <label>Team Member</label>
                    <div className="section-search search-ae search-member">
                        <div className="box-wrap">
                            <input type="text" name="search" id={this.props.leaderOrMember}
                                value={queryMembers}
                                onChange={this.handleSearch('member')}
                                placeholder="Search for team members to add ..." />
                        </div>
                        {queryMembers ? this.renderResults('member') : null}
                    </div>
                </div>

                 <div className="controls with-select position-relative margin-top-2">
                    <label>Team Member (other disciplines)</label>
                    <div className="section-search search-ae search-other-member">
                        <div className="box-wrap">
                            <input type="text" name="search"
                                value={queryMembersOther}
                                onChange={this.handleSearch('other')}
                                placeholder="Search for members to add ..." />
                        </div>
                        {queryMembersOther ? this.renderResults('other') : null}
                    </div>
                </div> 
            </div>
        )
    }
}

TeamMemberSearchAE.propTypes = {
    onAdd: PropTypes.func.isRequired,
    permissionsModule: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        teamLeaders_AE: state.additionalProjectsStore.teamLeaders_AE,
        otherMembers_AE: state.additionalProjectsStore.otherMembers_AE
    }
}

export default connect(mapStateToProps, { fetchTeamLeaders_AE, fetchOtherDiscMembers_AE })(TeamMemberSearchAE);